import { render, staticRenderFns } from "./profile-newsletter.vue?vue&type=template&id=0eba465b&scoped=true&"
import script from "./profile-newsletter.vue?vue&type=script&lang=js&"
export * from "./profile-newsletter.vue?vue&type=script&lang=js&"
import style0 from "./profile-newsletter.vue?vue&type=style&index=0&id=0eba465b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eba465b",
  null
  
)

export default component.exports